import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ProductCouponComponent } from './productcoupon.main';
import { ModalModule } from 'ngx-bootstrap/modal';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { LazyLoadImageModule, intersectionObserverPreset } from 'ng-lazyload-image';

@NgModule({
    declarations: [ProductCouponComponent],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        ModalModule.forRoot(),
        Ng2SearchPipeModule,
        LazyLoadImageModule.forRoot({ preset: intersectionObserverPreset }),
    ],
    bootstrap: [ProductCouponComponent],
})
export class ProductCouponModule {}
